/**
 * File: apps/qbench-cp/reactapp/src/Dashboard/index.js
 *
 * Purpose: Renders the dashboard card container that hosts the routed portal page content.
 *
 * Scope: Dashboard layout wrapper for the customer portal's authenticated pages.
 *
 * Tags: customer-portal
 *
 * Overview: Wraps the App/routes `Content` router in a CardContainer with a wide-screen style
 *     variant and a Suspense boundary showing a Loading fallback while lazily loaded route
 *     components resolve. Acts as the layout shell between the authenticated app view and the
 *     per-page routed content.
 *
 * Exports: Dashboard — default export, the component that renders the routed page content
 *     inside the dashboard's card layout.
 */

import React from 'react';
import CardContainer from 'shared/layout/CardContainer';
import Content from '../App/routes';
import Loading from 'shared/layout/Loading';
import { StyledDashboard } from './styles';
const Dashboard = (props) => {
  return (
    <StyledDashboard>
      <React.Suspense fallback={<Loading />}>
        <CardContainer className="wideScreen">
          <Content />
        </CardContainer>
      </React.Suspense>
    </StyledDashboard>
  );
};

export default Dashboard;
